// SPDX-License-Identifier: AGPL-3.0-or-later
import type {VoiceState} from '@app/features/gateway/types/GatewayVoiceTypes';
export interface ParsedVoiceParticipantIdentity {
	userId: string;
	connectionId: string;
}
export function parseVoiceParticipantIdentity(identity: string): ParsedVoiceParticipantIdentity {
	const match = identity.match(/^user_(\d+)_(.+)$/);
	return {userId: match?.[1] ?? '', connectionId: match?.[2] ?? ''};
}
interface IsVoiceParticipantActuallySpeakingArgs {
	isSpeaking: boolean;
	voiceState: VoiceState | null;
	isMicrophoneEnabled: boolean;
}
export function isVoiceParticipantActuallySpeaking({
	isSpeaking,
	voiceState,
	isMicrophoneEnabled,
}: IsVoiceParticipantActuallySpeakingArgs): boolean {
	if (!isSpeaking) return false;
	if (!isMicrophoneEnabled) return false;
	if (voiceState?.self_mute ?? false) return false;
	if (voiceState?.mute ?? false) return false;
	return true;
}
